import { Route } from 'react-router-dom'
import Login from '../login/Login'
import Registro from '../registro/Registro'
import Verificar from '../registro/Verificar'

const PublicRoutes = () => (
  <>
    <Route exact path="/" element={<Login />} />
    <Route path="/Login" element={<Login />} />
    <Route path="/Registro" element={<Registro />} />
    <Route path="/Verificar/:idUsuario/:codigoVerif" element={<Verificar />} />
  </>
)

export default PublicRoutes
